import { Typography } from "@mui/material";
import Dialog from "../../../../components/dialog/dialog";
import { ChangeRateTypeModalStyled } from "./change-rate-type.style";

const ChangeRateTypeModal = (props) => {
  const { onClose, message, onConfirm } = props;
  return (
    <Dialog
      confirmBtnTitle="Continue"
      closeBtnTitle={"Cancel"}
      isConfirming={false}
      disableConfirmBtn={false}
      onConfirm={onConfirm}
      onClose={onClose}
    >
      <ChangeRateTypeModalStyled>
        <Typography variant="h3" sx={{ marginTop: "10px" }}>
          Confirmation
        </Typography>

        <Typography sx={{ marginTop: "25px !important" }} variant="body2">
          {message}
        </Typography>
      </ChangeRateTypeModalStyled>
    </Dialog>
  );
};

export default ChangeRateTypeModal;
